import axios from './axios';

export default {
  get: async query => {
    const params = { params: query };
    const { data } = await axios.get('/notices', params);
    return data;
  },

  getCount: async query => {
    const params = { params: query };
    const { data } = await axios.get('/notices/count', params);
    return data;
  },

  updateStatus: async (id, body) => {
    const { data } = await axios.put(`/notices/${id}`, body);
    return data;
  },

  delete: async id => {
    const { data } = await axios.delete(`/notices/${id}`);
    return data;
  }
};
